const fixUndefined = (obj) => JSON.parse(JSON.stringify(obj, (_, value) => typeof value === 'undefined' ? null : value))

module.exports = fixUndefined